var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBbdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7.70443C15.5463 8.0634 15.0503 8.3678 14.5513 8.6173C12.7096 9.5381 10.3521 10 8 10C5.64787 10 3.29044 9.5381 1.44872 8.6173C0.94966 8.3678 0.45372 8.0634 0 7.70443V10C0 11.0575 0.83807 12.0759 2.34315 12.8284C3.84341 13.5786 5.87823 14 8 14C10.1218 14 12.1566 13.5786 13.6569 12.8284C15.1619 12.0759 16 11.0575 16 10V7.70443ZM16 13.7044C15.5463 14.0634 15.0503 14.3678 14.5513 14.6173C12.7096 15.5381 10.3521 16 8 16C5.64787 16 3.29044 15.5381 1.44872 14.6173C0.94966 14.3678 0.45372 14.0634 0 13.7044V16C0 18.2091 3.58172 20 8 20C12.4183 20 16 18.2091 16 16V13.7044ZM16 4C16 1.79086 12.4183 0 8 0C3.58172 0 0 1.79086 0 4C0 5.0575 0.83807 6.07589 2.34315 6.82843C3.84341 7.57856 5.87823 8 8 8C10.1218 8 12.1566 7.57856 13.6569 6.82843C15.1619 6.07589 16 5.0575 16 4Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbdd);
export default __webpack_public_path__ + "static/media/bbdd.903b6d511c319639ccbef1df3a37eb41.svg";
export { ForwardRef as ReactComponent };